var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbayaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5488 15.436C17.5889 16.6768 17.5857 18.2102 17.57 19.5253C17.5538 20.8884 17.5456 21.57 17.1064 22.003C16.6672 22.436 15.976 22.436 14.5937 22.436L9.40634 22.436C8.02398 22.436 7.33279 22.436 6.89359 22.003C6.45438 21.57 6.44625 20.8884 6.42997 19.5253C6.41428 18.2102 6.41113 16.6768 6.45124 15.436M17.5488 15.436C17.445 12.2257 17.1556 8.79785 16.51 6.43604M17.5488 15.436H19.4165C20.1808 15.436 20.563 15.436 20.8004 15.1847C21.0377 14.9334 21.016 14.5678 20.9725 13.8366C20.733 9.80919 19.6338 6.59461 18.7273 4.71789C18.4606 4.16575 18.3273 3.88968 17.9998 3.61424C17.6723 3.33881 17.315 3.23694 16.6003 3.03321L14.5056 2.43604C14.0044 3.43604 13.0022 3.93604 12 3.93604C10.9978 3.93604 9.99555 3.43604 9.49444 2.43604L7.39966 3.03321C6.68503 3.23694 6.32771 3.33881 6.00022 3.61424C5.67273 3.88968 5.53939 4.16575 5.2727 4.71789C4.36625 6.59461 3.26703 9.80919 3.0275 13.8366C2.98401 14.5678 2.96227 14.9334 3.19965 15.1847C3.43703 15.436 3.8192 15.436 4.58354 15.436H6.45124M6.45124 15.436C6.55501 12.2257 6.84442 8.79785 7.48999 6.43604",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.436H20.5M3.5 12.436H6.5",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.43604L12 9.43604",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbayaIcon);
export default __webpack_public_path__ + "static/media/abaya-icon.5d4df18797daacdb147e49a2a0268683.svg";
export { ForwardRef as ReactComponent };